import { tns } from "../vendor/tiny-slider/src/tiny-slider";

const wrappers = document.querySelectorAll('.block-stats')
const sliders = document.querySelectorAll('.stats')

wrappers.forEach(wrapper => {
    const slider = wrapper.querySelector('.stats')
    const controls = wrapper.querySelector('.stats__controls')

    const new_slider = new tns({
        container: slider,
        speed: 800,
        items: 1,
        gutter: 20,
        controlsContainer: controls,
        navPosition: "bottom",
        responsive: {
            "769": {
                items: 2,
            },
            "992": {
                items: 3,
            }
        },
        autoplay: true,
        autoplayTimeout: 6000,
        autoplayHoverPause: true,
        autoplayButtonOutput: false,
    })
});
